(function($) {
	//url paramaters
	$.urlParam = function(name) {
		var results = new RegExp("[?&]" + name + "=([^&#]*)").exec(
			window.location.href
		);
		if (results == null) {
			return 0;
		}
		return results[1] || 0;
	};
})(jQuery);

export function getUrlArray(url = location.href) {
	// Add defensive programming to prevent undefined errors
	if (!url || typeof url !== 'string') {
		return [];
	}
	var cleanUrl = url.replace(/\/$/, ""); /* remove optional end / */
	return cleanUrl.split("/");
}

export function isHubPaginatedPage(url = location.href) {
	try {
		var pathname = new URL(url, window.location.origin).pathname;
		return /\/page\/\d+\/?$/i.test(pathname);
	} catch (error) {
		return false;
	}
}

export function getHubBaseUrl(url = location.href) {
	var hubUrl = new URL(url, window.location.origin);
	hubUrl.search = "";
	hubUrl.hash = "";
	hubUrl.pathname = hubUrl.pathname.replace(/\/page\/\d+\/?$/, "/");
	if (!hubUrl.pathname.endsWith("/")) {
		hubUrl.pathname += "/";
	}
	return hubUrl.toString();
}

/**
 * Hub URL with ?filter= for bookmarkable filtered views (page 1 only).
 *
 * @param {string} filter Term slug.
 * @param {string} url    Optional base URL.
 * @return {string}
 */
export function getHubFilterUrl(filter, url = location.href) {
	var hubUrl = new URL(getHubBaseUrl(url), window.location.origin);
	if (filter && filter !== "all") {
		hubUrl.searchParams.set("filter", filter);
	}
	return hubUrl.toString();
}

/**
 * Update the address bar with ?filter= without reloading.
 *
 * @param {string}  filter  Term slug, or "all" to clear.
 * @param {boolean} replace Use replaceState when applying URL on first load.
 */
export function setHubFilterUrl(filter, replace = false) {
	if (!window.history) {
		return;
	}
	var nextUrl =
		filter && filter !== "all"
			? getHubFilterUrl(filter)
			: getHubBaseUrl();
	var state = { filter: filter || "all" };
	if (replace && window.history.replaceState) {
		window.history.replaceState(state, "", nextUrl);
	} else if (window.history.pushState) {
		window.history.pushState(state, "", nextUrl);
	}
}
